import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePrivateCompanyLeadSpecialFee {
  privateCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdatePrivateCompanyLeadSpecialFee = ({
  privateCompanyLeadId,
  onSuccess,
  onError,
}: UseUpdatePrivateCompanyLeadSpecialFee) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['updatePrivateCompanyLeadSpecialFee'],
    mutationFn: async (data: {
      id: string
      target_id?: string
      target_type?: string
      value?: string
      not_use_if_has_special_fee?: boolean
      execution_priority?: number
    }) => {
      const private_company_lead = {
        fee_rule_attributes: {
          special_entries_attributes: {
            id: data.id,
            target_id: data.target_id === 'all' ? null : data.target_id,
            target_type: data.target_type,
            value: data.value,
            not_use_if_has_special_fee: data.not_use_if_has_special_fee,
            execution_priority: data.execution_priority,
          },
        },
      }

      await privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
